import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ColorModeContext, tokens } from "../assets/theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import Tooltip from '@mui/material/Tooltip';
import { Avatar } from "@mui/material";
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { deepOrange, deepPurple } from '@mui/material/colors';
import LogoutIcon from '@mui/icons-material/Logout';
import { setPBIReportList, setTenantWorkspace } from '../features/auth/authSlice'
import { selectCurrentUser, selectPBIWorkspace, selectPBIWorkspaceList} from "../features/auth/authSlice"
import { setIsStandardDB } from '../features/data/dataSlice'
import { usePbiReportListMutation } from '../features/auth/authApiSlice'
import Logout from './logout'
import Spinner from './Spinner'
import PrivacyPolicy from '../features/auth/PrivacyPolicy'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const dispatch = useDispatch()
  const user = useSelector(selectCurrentUser);
  const workspaceid = useSelector(selectPBIWorkspace);
  const workspacelist = useSelector(selectPBIWorkspaceList);
  const [errMsg, setErrMsg] = useState('')
  const [spinnerLoad, setSpinnerLoad] = useState(false)
  const [ pbiReportList, { isPBIReportLoading } ] = usePbiReportListMutation()
  const [openPopup, setOpenPopup] = useState(false);

  const handleOnChangeWorkspacePBIReportList = async (workspacedetails) => {
    try {
      const workspaceid = { "workspaceId": workspacedetails }
      setSpinnerLoad(true)
      const getReportList =  await pbiReportList(workspaceid).unwrap()
      if(getReportList && getReportList.reports) {
        let report_list = getReportList.reports;
        let sortedReportList = report_list.slice().sort((a, b) => a.name.localeCompare(b.name));
       setTimeout(() => {
        dispatch(setPBIReportList(sortedReportList))
        setSpinnerLoad(false)
        if(sortedReportList.length){
          const stdbectobi = sortedReportList.filter(report => report.name.toLocaleLowerCase().includes('_st_db_ecto_bi'));
          stdbectobi.length ? dispatch(setIsStandardDB(true)) : dispatch(setIsStandardDB(false))
        }
       }, 1000);
      }
     
    } catch (err) {
        if (!err?.originalStatus) {
            // isLoading: true until timeout occurs
            setErrMsg('No Server Response');
        } else if (err.originalStatus === 400) {
            setErrMsg('Missing Username or Password');
        } else if (err.originalStatus === 401) {
            setErrMsg('Unauthorized');
        } else {
            setErrMsg('Login Failed');
        }
       // errRef.current.focus();
    }
  }


  const userinitials = user && user.charAt(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openLogout, setOpenLogout] = useState(false);
  const handleOpen = () => {
    setOpenLogout(true); 
  }
  const handleLogoutClose = () => setOpenLogout(false);

  const handleLogout = () => {
    window.location.reload(false);
  }

  const handleChangeWorkspace = (event) => {
    dispatch(setTenantWorkspace(event.target.value))
    handleOnChangeWorkspacePBIReportList(event.target.value);
  }
  
  return (
    <>
    <Box display="flex" className="topbar" justifyContent="space-between" p={2}>
      {/* <Typography
              className="logotitle"
              variant="h4"
              color={colors.grey[200]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Enacto BI
      </Typography> */}
            <div className='logoinside'>
                <img title="10.2.0-Snapshot [Build# 91805de6]" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAAAiCAYAAABoZDaJAAADPElEQVR42u1aS3LbMAzNtrt202Unk0iabtKhlFVWzRF6g/QG7Q3aGzQ3iG/QbrNIZE9murVv0N7AukFLSKRNgeBHoSI5GbwZLkxSIIgHggDHR0cMBoPBYDAYDMbB4C47P8XtMXMY4+Lh7OwNZXOyf5mX/3DDAmPmMMZFXVTfKZuT/Uwik8h4aSTWx+L1fVZ+XGXiW9ty8QV+D97Ae3Hcyon8Xs9t1yzEVZ0LcajkxOo6OYlAHigl+7fUXNn+1IX4FFIS5izz6ob4fk1tFowBskNrglNQc0BvtE+Q1SyL8q9vrtTlszUu18Djq7xcDtV1NhLl77q3oby6bomVm8D9PiU9m4RW99fskw2G6wxYXVP9q6L8ZRk+q77u9MnEZTe/XGAZppxujXLhG9drafnRupr6pJKoSDGbk0RCaGN4pLANJy49JG7AoykHML0dNtsbkyfH53SgR3fK7RNuGR7mKkL7MsqFId+KOPA9Hu9kDdd1LBKDTYdRvCEzhFBK6s2S4VQRHBrHJ5ZYc0MR0IZKiuB9uN0YMvDcrcsxezbZjzcxutrRqtM1mUSYaDanwoR3h0j0KRNDInVKQobZE0CFSRk+1VrBkCn3a50sx3gXlm3Co3Wd6k6kBM5BYnTkoBOcrU5oeskL4aBAjDY6ecca4+AQSbpORiLhlTOR2MC6vubxfOvOM64KZ+KlHKLxjafoOiGJ4dBGbSKJxIgQ5a1BifIAlwg42bGaSk6c4+puTdF10hIDe2OIRN/FHZ3YoDrOZRgwItSvvbuuO2FN5Pc04apUCo2n6DopiURI3XrvFV0mJJBIyF1ThtHlkVl/UUmLSTJ+OXIlMJ6Qi/bxOF2nf7GxMrnqRoWStbNgTiCRXDOrfsKTVvusVYgrbRTK81GYa3xhDZcr+PWGCqn2esN1neXttA0txHPVrog3CBiDxJ2Xu9aU/fgEUuSYoS/mbsJOgSORWfSn6DqIxNFf39WLx64RCcOTrdnWaV3yg95Yf6hSotanSJ+OKfQboivDYTTrIUO9NA3JahlzkojKoDYcyTvJfKdkPAMQyUfjykgZB4zb0w9v4U9FDyfn735fXLxiizAYDAaDwWAwGE+B//hP6FZWGmyRAAAAAElFTkSuQmCC" />
                <Typography
                    className="logotitle"
                    variant="h4"
                    color={colors.grey[200]}
                    sx={{ m: "15px 0 5px 20px" }}
                  >
                    Enacto Analytics
            </Typography>
            </div>
      {/* ICONS */}
      <Box display="flex">
        {/* <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton> */}
          <FormControl sx={{ m: 0, minWidth: 120 }}>
            <Select
              value={workspaceid}
              inputProps={{ 'aria-label': 'Without label' }}
              className="dpworkspace"
              onChange={handleChangeWorkspace}
            >
              {workspacelist.map((option) => (
                <MenuItem value={option.workspaceId}>{option.name}</MenuItem>
          ))}
            </Select>
          </FormControl>
        {/* <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton> */}
        <Link to="/home/userpreference">
          <IconButton>
            <SettingsOutlinedIcon />
          </IconButton>
        </Link>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }} className="textCapital">{userinitials}</Avatar>
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
    <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Link className="linkmenucolor" to="/home/userprofile">
          <MenuItem className="textCapital" onClick={handleClose}>
            <Avatar /> {user}
          </MenuItem>
        </Link>
        {/* <MenuItem onClick={handleClose}>
          <Avatar /> My account
        </MenuItem> */}
        <Divider />
        <MenuItem onClick={() => setOpenPopup(true)}  style={{display: 'flex', paddingLeft: 30}}>
          Privacy Policy
        </MenuItem>
        <Divider /> 
        <MenuItem onClick={handleOpen}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
        
      </Menu>
      <Logout openLogout={openLogout} handleLogoutClose={handleLogoutClose} />
      {openPopup && <PrivacyPolicy open={openPopup} onClose={() => setOpenPopup(false)} />}
      { spinnerLoad && (<Spinner />) }
    </>
  );
};

export default Topbar;
